import { RouteEnum } from '@/constants/enums/RouteEnum';
import { env } from '@/env';
import auth from '@/middleware/auth';
import customHome from '@/middleware/customHome';
import lineBinding from '@/middleware/lineBinding';
import urlToken from '@/middleware/urlToken';
import { baseFeatureRoutes } from '@/router/routes/baseFeatures';
import { businessCommon } from '@/router/routes/businessCommon';
import { landingPageRoutes } from '@/router/routes/landingPage';
import { loginTypeRoutes } from '@/router/routes/loginType';
import { newV2Funday } from '@/router/routes/newV2Funday';
import { paidFeatureRoutes } from '@/router/routes/paidFeatures';
import type { RouteRecordRaw } from 'vue-router';

export const fullRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: RouteEnum.Root,
    redirect: { name: RouteEnum.Index },
    children: [
      {
        /**
         * 首頁
         */
        path: '/home',
        name: RouteEnum.Index,
        component: () => import('@/views/home/index.vue'),
        meta: {
          middleware: [auth, customHome, lineBinding]
        }
      }
    ]
  },
  {
    /**
     * 第三方手機註冊驗證頁
     */
    path: '/third-party-sms',
    name: RouteEnum.ThirdPartySMSVerify,
    component: () => import('@/views/ThirdPartySMSView.vue'),
    meta: {
      middleware: [auth],
      allowAllVersions: true,
      layout: 'NoLayout'
    },
    beforeEnter: async () => {
      /**
       * 已完成手機驗證的使用者，導回首頁或對應站台
       */
      const userStore = useUserStore();
      if (userStore.isPayUser || userStore.phoneExist) {
        if (userStore.isV2OfficialUser) {
          window.location.href = env.officialV2Url;
          return false;
        }
        return { name: RouteEnum.Index };
      }
    }
  },
  {
    /**
     * 線上合約終止申請頁
     */
    path: '/contract-termination',
    name: RouteEnum.ContractTermination,
    component: () => import('@/views/ContractTerminationView.vue'),
    meta: {
      middleware: [urlToken, auth],
      allowAllVersions: true,
      layout: 'NoLayout'
    }
  },
  {
    /**
     * 使用者初始設定頁面
     * @remarks 用於完成註冊後的初始設定
     * 初始設定關卡：
     * - 設定等級
     * - 學習目標 (課程七大主題)
     */
    path: '/profile-setup/:settingsType(level|theme)?',
    name: RouteEnum.ProfileSetup,
    component: () => import('@/views/profileSetup/index.vue'),
    meta: {
      layout: 'NoLayout',
      allowAllVersions: true,
      middleware: [auth]
    },
    beforeEnter: async (to) => {
      /**
       * 已完成初始設定的使用者，導回首頁
       * @remarks 等級不能變更
       */
      const user = useUserStore();
      if (to.params.settingsType === 'level' && !user.isAfterSignUp && user.userData.hasLevel) {
        return { name: RouteEnum.Index };
      }
    }
  },
  /**
   * 登入類型相關路由
   */
  ...loginTypeRoutes,
  {
    /**
     * Thank You Page
     * @remarks 註冊完成感謝頁
     */
    path: '/thank-you',
    name: RouteEnum.ThankYou,
    component: () => import('@/views/ThankYouView.vue'),
    meta: {
      layout: 'NoLayout',
      allowAllVersions: true,
    }
  },
  /**
   * 基礎可用功能路由
   */
  ...baseFeatureRoutes,
  /**
   * 付費會員可用功能路由
   */
  ...paidFeatureRoutes,
  /**
   * 行銷廣告用的活動單頁面 or 其他不需登入即可瀏覽的頁面
   */
  ...landingPageRoutes,
  /**
   * B2B 會員共享功能路由
   */
  ...businessCommon,
  /**
   * v2 共用頁面路由
   */
  ...newV2Funday,
  {
    /**
     * 捕捉所有未定義路由，重定向到首頁
     */
    path: '/:catchAll(.*)',
    redirect: { name: RouteEnum.Index }
  }
];
